import 'shaka-player/dist/controls.css';
import shaka from 'shaka-player/dist/shaka-player.ui.js';

class Nielsen {

    constructor(options) {

        console.log('Nielsen Plugin');

        this.id = options.id;
        this.videoElement = options.videoElement;
        this.shakaPlayerUi = options.shakaPlayerUi;
        this.analyticsApiResponse = options.analyticsApiResponse;
        this.streamsApiResponse = options.streamsApiResponse;
        this.data = document.getElementById(this.id);
        this.SimplestreamPlayer = options.SimplestreamPlayer;
        this.playerTech = options.playerTech;

        this.shakaPlayer = null;
        this.bitmovinPlayer = null;

        !function (e, n) {
            function t(e) { return "object" == typeof e ? JSON.parse(JSON.stringify(e)) : e }
            e[n] = e[n] || {
                nlsQ: function (o, r, c) {
                    var s = e.document, a = s.createElement("script");
                    a.async = 1; a.src = ("http:" === e.location.protocol ? "http:" : "https:") + "//cdn-gl.nmrodam.com/conf/" + o + ".js#name=" + r + "&ns=" + n;
                    var i = s.getElementsByTagName("script")[0];
                    i.parentNode.insertBefore(a, i);
                    return e[n][r] = e[n][r] || {
                        g: c || {},
                        ggPM: function (o, c, s, a, i) {
                            e[n][r].q = e[n][r].q || [];
                            try { var l = t([o, c, s, a, i]); e[n][r].q.push(l) }
                            catch (err) { console && console.log && console.log("Error: Cannot register event in Nielsen SDK queue.") }
                        },
                        trackEvent: function (o) {
                            e[n][r].te = e[n][r].te || [];
                            try { var evData = t(o); e[n][r].te.push(evData) }
                            catch (err) { console && console.log && console.log("Error: Cannot register event in Nielsen SDK queue.") }
                        }
                    }, e[n][r]
                }
            }
        }(window, "NOLBUNDLE");

        this.nSdkInstance = NOLBUNDLE.nlsQ("PE02491CE-C960-418E-A57B-402CD1C42064", "nlsnInstance", {nol_sdkDebug: "debug"});

        this.init();

    }

    init() {
        let lastReportedTimestamp = -1; // Stores the last value sent to ggPM
        let isPlaying = false; // This will now be set by 'playing' event
        let adPlaying = false;
        let isSeeking = false;
        let lastTimeUpdateCall = 0;
        const dataType = this.data.dataset.type; // 'live', 'vod', 'show'
        let adSegmentStartTime= 0;
        let contentSegmentStartTime= 0;


        // State for live stream pause/resume logic
        let isPausedForLive = false; // Specific flag for live pause state
        let timestampAtPause = null; // Unix timestamp when live stream paused
        let videoTimeAtPause = null; // videoElement.currentTime when live stream paused

        // SDK Initialization
        this.nSdkInstance.ggPM('loadMetadata', this.analyticsApiResponse);
        this.debug('loadMetadata content', this.analyticsApiResponse);

        const videoElement = this.videoElement;
        if (!videoElement) {
            console.error("Video element not found!");
            return;
        }

        if (this.playerTech === 'shaka') {
            this.shakaPlayer = this.shakaPlayerUi.getControls().getPlayer();
            const adManager = this.shakaPlayer.getAdManager();

            console.log('...getAdmanager ', this.shakaPlayer.getAdManager());

            adManager.addEventListener(shaka.ads.Utils.AD_STARTED, (event) => {
                this.debug('Ad Started');
                adPlaying = true;
                isPlaying = true; // Ad is playing
                adSegmentStartTime = videoElement.currentTime;
                isSeeking = false;
                isPausedForLive = false;
                timestampAtPause = null;
                videoTimeAtPause = null;
                this.nSdkInstance.ggPM('loadMetadata', event.ad.getVastAdId());
                this.nSdkInstance.ggPM('setPlayheadPosition', 0);
                lastReportedTimestamp = 0;
                this.debug('setPlayheadPosition (ad start) = 0');
            });

            adManager.addEventListener(shaka.ads.Utils.AD_STOPPED, () => {
                this.debug('Ad Stopped/Completed');
                adPlaying = false;
                isPlaying = true;
                contentSegmentStartTime = videoElement.currentTime;
                let contentTime;
                if (dataType === 'live') {
                    contentTime = Math.floor(Date.now() / 1000);
                    this.debug(
                        `Ad Stopped: Calculating post-ad time (Live): ${contentTime}`
                    );
                } else {
                    contentTime = Math.floor(videoElement.currentTime);
                    this.debug(
                        `Ad Stopped: Calculating post-ad time (VOD/Show): ${contentTime}`
                    );
                }
                if (!isNaN(contentTime)) {
                    this.nSdkInstance.ggPM('setPlayheadPosition', 0);
                    lastReportedTimestamp = contentTime;
                    this.debug(
                        `setPlayheadPosition (ad end, content resume) = ${contentTime}`
                    );
                }
            });

            adManager.addEventListener(shaka.ads.Utils.AD_COMPLETE, () => {
                adPlaying = false;
                isPlaying = true;
                contentSegmentStartTime = videoElement.currentTime;
                let contentTime;
                if (dataType === 'live') {
                    contentTime = Math.floor(Date.now() / 1000);
                } else {
                    contentTime = Math.floor(videoElement.currentTime);
                    this.debug(
                        `All Ads Completed: Calculating post-ad time (VOD/Show): ${contentTime}`
                    );
                    this.nSdkInstance.ggPM('loadMetadata', this.analyticsApiResponse);
                }
                if (!isNaN(contentTime)) {
                    this.nSdkInstance.ggPM('setPlayheadPosition', 0);
                    lastReportedTimestamp = contentTime;
                    this.debug(
                        `setPlayheadPosition (all ads end, content resume) = ${contentTime}`
                    );
                }
            });

            adManager.addEventListener(shaka.ads.Utils.AD_ERROR, () => {
                this.debug('Ad Error');
                adPlaying = false;
                let contentTime;
                if (dataType === 'live') {
                    contentTime = Math.floor(Date.now() / 1000);
                    this.debug(`Ad Error: Calculating post-ad time (Live): ${contentTime}`);
                } else {
                    contentTime = Math.floor(videoElement.currentTime);
                    this.debug(
                        `Ad Error: Calculating post-ad time (VOD/Show): ${contentTime}`
                    );
                }
                if (!isNaN(contentTime)) {
                    this.nSdkInstance.ggPM('setPlayheadPosition', contentTime);
                    lastReportedTimestamp = contentTime;
                }
            });
        }

        videoElement.addEventListener('play', () => {
            if (dataType === 'live' && !adPlaying) {
                const playTimestamp = Math.floor(Date.now() / 1000);
                this.nSdkInstance.ggPM('setPlayheadPosition', playTimestamp);
                lastReportedTimestamp = playTimestamp;
                this.debug(`setPlayheadPosition on play (live) = ${playTimestamp}`);
            }
        });

        videoElement.addEventListener('playing', () => {
            this.debug('Video Playing event (playback started/resumed)');
            if (!adPlaying) {
                isPlaying = true;
                contentSegmentStartTime = videoElement.currentTime;
                lastReportedTimestamp   = 0;
                this.nSdkInstance.ggPM('setPlayheadPosition', 0);

                if (dataType === 'live') {
                    const initialTimestamp = Math.floor(Date.now() / 1000);
                    this.nSdkInstance.ggPM('setPlayheadPosition', initialTimestamp);
                    lastReportedTimestamp = initialTimestamp;
                    this.debug(`Initial setPlayheadPosition (live) = ${initialTimestamp}`);
                }
            }
            isPausedForLive = false;
        });

        videoElement.addEventListener('pause', () => {
            if (!isPlaying && !adPlaying) return;

            this.debug('Video Pause event');
            isPlaying = false;
            const currentVideoTime = videoElement.currentTime;

            let reportablePauseTime;

            if (!adPlaying) {
                // Content Pause
                if (dataType === 'live') {
                    isPausedForLive = true;
                    timestampAtPause = lastReportedTimestamp;
                    videoTimeAtPause = currentVideoTime;
                    reportablePauseTime = timestampAtPause;
                    this.debug(
                        `Paused live stream. Storing Timestamp: ${timestampAtPause}, Video time: ${videoTimeAtPause}`
                    );
                    this.debug(`stop (live content) = ${reportablePauseTime}`);
                } else {
                    // VOD/Show Pause
                    isPausedForLive = false;
                    reportablePauseTime = Math.floor(currentVideoTime);
                    this.debug(`stop (VOD/Show content) = ${reportablePauseTime}`);
                    lastReportedTimestamp = reportablePauseTime;
                }
                if (
                    typeof reportablePauseTime === 'number' &&
                    !isNaN(reportablePauseTime)
                ) {
                    this.nSdkInstance.ggPM('stop', reportablePauseTime);
                } else {
                    this.debug(
                        `Invalid pause time calculated (${reportablePauseTime}), skipping stop event.`
                    );
                }
            } else {
                // Ad Pause
                reportablePauseTime = Math.floor(currentVideoTime);
                this.debug(`Paused during ad. Video time: ${reportablePauseTime}`);
            }
        });

        videoElement.addEventListener('seeking', () => {
            if (adPlaying) {
                return;
            }
            isSeeking = true;
            this.debug('Seeking started...');
            if (dataType === 'live') {
                this.debug('Seeking in live stream, clearing pause state.');
                isPausedForLive = false;
                timestampAtPause = null;
                videoTimeAtPause = null;
            }
        });

        videoElement.addEventListener('seeked', () => {
            if (adPlaying) {
                return;
            }
            isSeeking = false;
            const seekedVideoTime = Math.floor(videoElement.currentTime);
            this.debug(`Seeking ended at video time: ${seekedVideoTime}`);

            if (dataType === 'vod' || dataType === 'show') {
                this.nSdkInstance.ggPM('setPlayheadPosition', seekedVideoTime);
                lastReportedTimestamp = seekedVideoTime;
                this.debug(`Seeked (VOD/Show): Reported ${seekedVideoTime}`);
            }
        });

        videoElement.addEventListener('timeupdate', () => {
            const now = Date.now();
            if (now - lastTimeUpdateCall < 250) return;
            lastTimeUpdateCall = now;

            if (dataType === 'live') {
                if (adPlaying) return;
            } else {
                // For VOD/shows, use the original condition
                if ((isSeeking && !adPlaying) || (!isPlaying && !isPausedForLive)) {
                    return;
                }
            }

            let calculatedTimestamp;

            if (adPlaying) {
                calculatedTimestamp = Math.floor(videoElement.currentTime - adSegmentStartTime);
            } else if (dataType === 'live') {
                const liveThreshold = 5;
                let isNearLiveEdge = false;

                try {
                    if (videoElement.seekable && videoElement.seekable.length > 0) {
                        const liveEdgeTime = videoElement.seekable.end(
                            videoElement.seekable.length - 1
                        );
                        const timeFromLiveEdge = liveEdgeTime - videoElement.currentTime;
                        isNearLiveEdge = timeFromLiveEdge < liveThreshold;
                    } else {
                        isNearLiveEdge = true;
                    }
                } catch (e) {
                    isNearLiveEdge = true;
                }

                if (isPausedForLive) {
                    calculatedTimestamp =
                        timestampAtPause !== null
                            ? timestampAtPause
                            : Math.floor(Date.now() / 1000);
                } else if (isNearLiveEdge) {
                    calculatedTimestamp = Math.floor(Date.now() / 1000);
                    if (timestampAtPause !== null) {
                        timestampAtPause = null;
                        videoTimeAtPause = null;
                    }
                } else if (
                    timestampAtPause !== null &&
                    videoTimeAtPause !== null &&
                    videoElement.currentTime >= videoTimeAtPause
                ) {
                    const elapsedPlaybackTime =
                        videoElement.currentTime - videoTimeAtPause;
                    calculatedTimestamp =
                        timestampAtPause + Math.floor(elapsedPlaybackTime);
                } else {
                    calculatedTimestamp = Math.floor(Date.now() / 1000);
                    if (timestampAtPause !== null) {
                        timestampAtPause = null;
                        videoTimeAtPause = null;
                    }
                }
            } else {
                // VOD or Show
                calculatedTimestamp = Math.floor(videoElement.currentTime - contentSegmentStartTime);
            }

            if (
                typeof calculatedTimestamp !== 'number' ||
                isNaN(calculatedTimestamp) ||
                calculatedTimestamp < 0
            ) {
                this.debug(
                    `Invalid calculated timestamp (${calculatedTimestamp}). Skipping report.`
                );
                return;
            }

            if (calculatedTimestamp !== lastReportedTimestamp) {
                this.debug(
                    `Reporting time: ${calculatedTimestamp} (Was: ${lastReportedTimestamp}, Ad: ${adPlaying}, Type: ${dataType}, LivePaused: ${isPausedForLive}, Playing: ${isPlaying})`
                );
                this.nSdkInstance.ggPM('setPlayheadPosition', calculatedTimestamp);
                lastReportedTimestamp = calculatedTimestamp;
            }
        });

    const handleTermination = (event) => {
            if (this.terminationHandled) return;
            this.terminationHandled = true;

            const endTime = Math.floor(videoElement.currentTime);
            if (!adPlaying) {
                this.debug(`end (${event.type}) = ${endTime}`);
                this.nSdkInstance.ggPM('end', endTime);
            } else {
                this.debug(`end during ad (${event.type}) = ${endTime}`);
            }
        };

        videoElement.addEventListener('ended', handleTermination);
        window.addEventListener('beforeunload', handleTermination);
        window.addEventListener('pagehide', handleTermination);

        this.terminationHandled = false;
    }



    debug(msg) {
        console.log('Nielsen: ' + msg);
    }

}

export default Nielsen;
